export const accountNameHandler = (
  firstName: string,
  lastName: string = ""
) => {
  if ((firstName + lastName).length > 15) {
    if (firstName.length > lastName.length) {
      return lastName ? `${lastName} .${firstName[0]}` : `${firstName}`;
    }
    return `${firstName} .${lastName[0]}`;
  }
  return `${firstName} ${lastName}`;
};

/**
 * Creates separators with coma in thousands
 * @param {number} num - number to be formatted
 * @param {string?} separator - one of ',' | ','
 * @param returnDefault
 * @return {string}
 */
export const thousandsSeparators = (
  num: number | string,
  separator: string = ",",
  returnDefault?: any
) => {
  if (num) {
    const numParts = num.toString().split(".");
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return numParts.join(".");
  }
  return returnDefault ?? "";
};

export const formikErrorHandler = (name: string, formikInstance: any) => {
  return (
    formikInstance.errors[name] &&
    formikInstance.touched[name] &&
    formikInstance.errors[name]
  );
};

export const dummyOptions = [
  {
    label: "Option One",
    value: "a",
  },
  {
    label: "Option Two",
    value: "b",
  },
  {
    label: "Option Three",
    value: "c",
  },
  {
    label: "Disabled Option",
    value: "d",
    isDisabled: true,
  },
];

export const NigerianStates = [
  {
    code: "01",
    state: "Abia",
  },
  {
    code: "02",
    state: "Adamawa",
  },
  {
    code: "03",
    state: "Akwa-Ibom",
  },
  {
    code: "04",
    state: "Anambra",
  },
  {
    code: "05",
    state: "Bauchi",
  },
  {
    code: "06",
    state: "Bayelsa",
  },
  {
    code: "07",
    state: "Benue",
  },
  {
    code: "08",
    state: "Borno",
  },
  {
    code: "09",
    state: "Cross-River",
  },
  {
    code: 10,
    state: "Delta",
  },
  {
    code: 11,
    state: "Ebonyi",
  },
  {
    code: 12,
    state: "Edo",
  },
  {
    code: 13,
    state: "Ekiti",
  },
  {
    code: 14,
    state: "Enugu",
  },
  {
    code: 37,
    state: "FCT",
  },
  {
    code: 15,
    state: "Gombe",
  },
  {
    code: 16,
    state: "Imo",
  },
  {
    code: 17,
    state: "Jigawa",
  },
  {
    code: 18,
    state: "Kaduna",
  },
  {
    code: 19,
    state: "Kano",
  },
  {
    code: 20,
    state: "Katsina",
  },
  {
    code: 21,
    state: "Kebbi",
  },
  {
    code: 22,
    state: "Kogi",
  },
  {
    code: 23,
    state: "Kwara",
  },
  {
    code: 24,
    state: "Lagos",
  },
  {
    code: 25,
    state: "Nasarawa",
  },
  {
    code: 26,
    state: "Niger",
  },
  {
    code: 27,
    state: "Ogun",
  },
  {
    code: 28,
    state: "Ondo",
  },
  {
    code: 29,
    state: "Osun",
  },
  {
    code: 30,
    state: "Oyo",
  },
  {
    code: 31,
    state: "Plateau",
  },
  {
    code: 32,
    state: "Rivers",
  },
  {
    code: 33,
    state: "Sokoto",
  },
  {
    code: 34,
    state: "Taraba",
  },
  {
    code: 35,
    state: "Yobe",
  },
  {
    code: 36,
    state: "Zamfara",
  },
];

export const copyText = (
  text: string,
  callback: (response: {
    state: string;
    message: string;
    text: string;
    error?: any;
  }) => void
) => {
  if (navigator.clipboard !== undefined) {
    //Chrome
    navigator.clipboard
      .writeText(text)
      .then(() =>
        callback({
          state: "success",
          message: "Copied to clipboard",
          text,
        })
      )
      .catch((err) =>
        callback({
          state: "failed",
          message: "Could not copy text: ",
          error: err,
          text,
        })
      );
  } else {
    // @ts-ignore
    // eslint-disable-next-line no-lonely-if
    if (window.clipboardData) {
      // Internet Explorer
      // @ts-ignore
      window.clipboardData.setData("Text", text);
      callback({
        state: "success",
        message: "Copied to clipboard",
        text,
      });
    } else {
      callback({
        state: "success",
        message: "Copied to clipboard",
        text,
      });
    }
  }
};

// export const exportWallet = (type: string = 'csv', start: string, stop: string, id: string | null | undefined) => {
//   return walletRequest.get(`/v1/wallet/account/user/to/${type}?accountId=${id}&fromDate=${start}&endDate=${stop}`);
// };

export const resolveUserTypeToTableData = <T>(
  data: T[],
  reshape?: (curObject: T) => T | object
) => {
  if (data?.length) {
    return data.reduce((res: any[], _cur, i) => {
      if (reshape) {
        const overwrite = reshape(_cur);
        res.push({ sn: i + 1, ...overwrite });
      } else res.push({ sn: i + 1, ..._cur });
      return res;
    }, []);
  }
  return data;
};

/**
 * Takes word and converts word to title case eg: word -> Word
 * @param {string} str - word to be converted
 * @return {string} - word in title case
 */
export const toTitleCase = (str: string): string => {
  if (str) {
    return str
      .toLowerCase()
      .trim()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }
  return str;
};

export const formatNumberToMoney = (
  number = 0,
  {
    countryCode = "NG",
    currencyCode = "NGN",
    minimumFractionDigits = 2,
    maximumFractionDigits = 20,
    formatDecimals = true,
  } = {}
) => {
  const formatter = new Intl.NumberFormat(`en-${countryCode}`, {
    style: currencyCode && "currency",
    currency: currencyCode,
    minimumFractionDigits: formatDecimals ? minimumFractionDigits : undefined,
    maximumFractionDigits: formatDecimals ? maximumFractionDigits : 20,
  });
  return formatter.format(number);
};

// export const dateFormat = (date: Date) => {
//   return {
//     filterType: format(new Date(date), 'dd/MM/yyy'),
//     inputType: format(new Date(date), 'dd-MM-yyy'),
//     tableType: format(new Date(date), 'dd MMMM yyyy - p'),
//   };
// };

export const getStatusColor = (status: string) => {
  const stat: any = {
    Successful: "success",
    Failed: "error",
    Pending: "pending",
  };
  return stat[status];
};
